import { Toaster } from 'components/ui/sonner';
import { ToastData } from 'interfaces/toast';
import { toast } from 'sonner';
import { createContext, useCallback, useContext, type ReactNode } from 'react';

type ToastContextValue = {
  addToast: (data: ToastData) => void;
  removeToast: (id?: string | number) => void;
};

const ToastContext = createContext<ToastContextValue>({
  addToast: (_data: ToastData) => {
    /* noop */
  },
  removeToast: (_id?: string | number) => {
    /* noop */
  },
});

type ToastProviderProps = {
  children: ReactNode;
};

export function ToastProvider({ children }: ToastProviderProps) {
  const addToast = useCallback((toastData: ToastData) => {
    const { title, description, type } = toastData;

    const options = description ? { description } : undefined;

    switch (type) {
      case 'success':
        toast.success(title, options);
        break;
      case 'warning':
        toast.warning(title, options);
        break;
      case 'error':
        toast.error(title, options);
        break;
      default:
        toast(title, options);
    }
  }, []);

  const removeToast = useCallback((id?: string | number) => {
    toast.dismiss(id);
  }, []);

  return (
    <ToastContext.Provider
      value={{
        addToast,
        removeToast,
      }}
    >
      {children}
      <Toaster richColors closeButton position="bottom-left" duration={5000} />
    </ToastContext.Provider>
  );
}

export const useToast = () => {
  return useContext(ToastContext);
};
